import { featureFlagGuard } from '@web/csl-lib-services';
import { HealthRecordLayoutComponent } from "./layouts/health-record-layout/health-record-layout.component";
import { HomeLayoutComponent } from './layouts/clinic-home-layout/home-layout.component';
import { LoginHomeComponent } from './components/login-home/login-home.component';
import { MsalGuard } from '@azure/msal-angular';
import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: '',
    component: LoginHomeComponent
  },
  {
    path: '',
    component: HomeLayoutComponent,
    children: [
      {
        path: 'hr-index',
        canActivate: [MsalGuard],
        data: {
          breadcrumb: 'Health Records'
        },
        loadComponent: () => import('./components/health-record-index/health-record-index.component').then(m => m.HealthRecordIndexComponent),
      }
      ,
      {
        path: 'mrr-index',
        canActivate: [MsalGuard],
        data: {
          breadcrumb: 'Medical Record Releases'
        },
        loadComponent: () => import('./components/medical-record-release-index/medical-record-release-index.component').then(m => m.MedicalRecordReleaseIndexComponent),
      }
      ,
      {
        path: 'scp-worklist',
        canActivate: [MsalGuard],
        data: {
          breadcrumb: 'Survivor Care Plan Upload Worklist'
        },
        loadComponent: () => import('./components/scp-upload-worklist/scp-upload-worklist.component').then(m => m.ScpUploadWorklistComponent),
      }
      ,
      {
        path: 'transfer',
        canActivate: [MsalGuard],
        data: {
          breadcrumb: 'Health Record Owner Transfers'
        },
        loadComponent: () => import('./components/health-record-owner-transfers/health-record-owner-transfers.component').then(m => m.HealthRecordOwnerTransfersComponent),
      }
      ,
      {
        path: 'clinic-docs',
        canActivate: [MsalGuard],
        data: {
          breadcrumb: 'Clinic Documents'
        },
        loadComponent: () => import('./components/clinic-documents/clinic-documents.component').then(m => m.ClinicDocumentsComponent),
      }
      ,
      {
        path: 'pfc-sessions',
        canActivate: [MsalGuard, featureFlagGuard('pfc_integration', '/hr-index')],
        data: {
          breadcrumb: 'Passport for Care'
        },
        loadComponent: () => import('./components/pfc-clinic-sessions/pfc-clinic-sessions.component').then(m => m.PfcClinicSessionsComponent),
      }
      ,
      {
        path: 'messages',
        canActivate: [MsalGuard],
        data: {
          breadcrumb: 'Messages'
        },
        loadComponent: () => import('./components/messages/messages.component').then(m => m.MessagesComponent),
      }
      ,
      {
        path: 'clinic-staff',
        canActivate: [MsalGuard],
        data: {
          breadcrumb: 'Clinic Staff'
        },
        loadComponent: () => import('./components/clinic-staff/clinic-staff.component').then(m => m.ClinicStaffComponent),
      }
      ,
      {
        path: 'users',
        canActivate: [MsalGuard],
        data: {
          breadcrumb: 'Users'
        },
        loadComponent: () => import('./components/users/users.component').then(m => m.UsersComponent),
      }
    ]
  },
  {
    path: 'hr/:healthRecordId',
    data: {
      breadcrumb: null
    },
    component: HealthRecordLayoutComponent,
    children: [
      {
        path: '',
        data: {
          breadcrumb: null
        },
        redirectTo: 'documents',
        pathMatch: 'full'
      },
      {
        path: 'documents',
        canActivate: [MsalGuard],
        data: {
          breadcrumb: 'Documents'
        },
        loadComponent: () => import('./components/health-record-documents/health-record-documents.component').then(m => m.HealthRecordDocumentsComponent),
      },
      {
        path: 'lg',
        canActivate: [MsalGuard],
        data: {
          breadcrumb: 'Legal Guardian'
        },
        loadComponent: () => import('./components/legal-guardianship/legal-guardianship.component').then(m => m.LegalGuardianshipComponent),
      },
      {
        path: 'details',
        canActivate: [MsalGuard],
        data: {
          breadcrumb: 'Survivor Details'
        },
        loadComponent: () => import('./components/survivor-details/survivor-details.component').then(m => m.SurvivorDetailsComponent),
      },
    ]
  }
];
